import Icon from '../Icon.vue'

Icon.register({
  'tif': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M7.854 11.121v3.895H6.626v-3.895H5.402V10.03h3.677v1.092zm1.867 3.895h1.226V10.03H9.721zm3.319-3.895v.876h1.85v1.093h-1.85v1.926h-1.227V10.03h3.39v1.092zm4.031 0v.876h1.85v1.093h-1.85v1.926h-1.226V10.03h3.39v1.092z'
      },
      {
        d: 'M10 5.003V2.827l2.176 2.176H10zM13 3l-.997-.997-2-2H1a1 1 0 00-1 1v18a1 1 0 001 1h13a1 1 0 001-1v-3h-2v2H2v-16h6v4a1 1 0 001 1h4v2h2V5l-2-2z'
      }
    ]
  }
})
